if (typeof ProductPage !== 'function') {
  class ProductPage extends HTMLElement {
    constructor() {
      super();

      this.section = this.closest('.shopify-section');
      this.productVariants = this.querySelector('product-variants');
      this.productVariants.addEventListener('variant:changed', this.onVariantChanged.bind(this));
      this.productVariants.addEventListener('combined-listing:working', this.onListingWorking.bind(this));
      this.productVariants.addEventListener('combined-listing:changed', this.onListingChanged.bind(this));
    }

    // -- Working states --

    working(e) {
      const fieldset = e.target.element?.closest('fieldset');
      const callouts = fieldset
        ? fieldset.querySelectorAll('[data-js-dynamic-option-label], [data-js-dynamic-option-description]')
        : [];

      return {
        showCalloutLoading: () => {
          callouts.forEach((el) => {
            el.style.backgroundColor = '#000';
            el.style.color = '#000';
            el.style.opacity = '0.09';
          });
        },
        resetCallouts: () => {
          callouts.forEach((el) => {
            el.style.backgroundColor = 'transparent';
            el.style.color = 'inherit';
            el.style.opacity = '1';
          });
        },
        showGalleryLoading: () => {
          const gallery = this.querySelector('.product-gallery');
          if (gallery) gallery.style.opacity = '0.5';
        },
        resetGallery: () => {
          const gallery = this.querySelector('.product-gallery');
          if (gallery) gallery.style.opacity = '1';
        },
      };
    }

    onVariantChanged(e) {
      return;
    }

    onListingWorking(e) {
      this.working(e).showCalloutLoading();
      this.working(e).showGalleryLoading();
    }

    onListingChanged(e) {
      const sectionContent = this.productVariants.sectionContent;
      const newSection = sectionContent.querySelector('product-page');
      if (!newSection) return;

      const wasExpanded = this.dataset.galleryExpanded === 'true';

      try {
        this.replaceWith(newSection);
      } catch (error) {
        console.error(error);
        return;
      }

      // Notify outside-the-section listeners (e.g. sticky add-to-cart) that the
      // product-page node was swapped — their cached references are now stale.
      document.dispatchEvent(
        new CustomEvent('product-page:replaced', {detail: {productPageId: newSection.id}})
      );

      if (wasExpanded) newSection.restoreGalleryExpansion();

      const targetId = e.target.element?.dataset?.optionValueId;
      if (targetId) {
        requestAnimationFrame(() => {
          const input = newSection.querySelector(`input[data-option-value-id="${targetId}"]`);
          input?.focus();
        });
      }
    }

    // -- Thumbnail navigation --

    thumbnailNavigationHelper(index = 0) {
      this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i) => {
        elm.classList.toggle('active', i == index);
      });
    }

    // -- Show more / gallery expansion --

    toggleGalleryExpansion() {
      const gallery = this.querySelector('.product-gallery');
      const grid = gallery?.querySelector('.grid--layout.grid-2');
      const button = gallery?.querySelector('.product-gallery__show-more-btn');
      if (!gallery || !grid || !button) return;

      const showText = button.querySelector('.show-text');
      const hideText = button.querySelector('.hide-text');
      const isExpanded = this.dataset.galleryExpanded === 'true';

      grid.classList.toggle('gallery-expanded', !isExpanded);
      showText.style.display = isExpanded ? 'inline' : 'none';
      hideText.style.display = isExpanded ? 'none' : 'inline';
      this.dataset.galleryExpanded = String(!isExpanded);

      if (isExpanded) gallery.scrollIntoView({behavior: 'smooth', block: 'start'});
    }

    restoreGalleryExpansion() {
      const gallery = this.querySelector('.product-gallery');
      const grid = gallery?.querySelector('.grid--layout.grid-2');
      const button = gallery?.querySelector('.product-gallery__show-more-btn');
      if (!gallery || !grid || !button) return;

      grid.classList.add('gallery-expanded');
      button.querySelector('.show-text').style.display = 'none';
      button.querySelector('.hide-text').style.display = 'inline';
      this.dataset.galleryExpanded = 'true';
    }

    // -- Media controls --

    _pauseAllMedia() {
      document.querySelectorAll('.product-gallery .js-youtube').forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      });
      document.querySelectorAll('.product-gallery .js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
      });
      document.querySelectorAll('.product-gallery video').forEach((video) => video.pause());
      document.querySelectorAll('.product-gallery product-model').forEach((model) => {
        if (model.modelViewerUI) model.modelViewerUI.pause();
      });
    }

    _playMedia(media) {
      if (!media) return;
      switch (media.dataset.productMediaType) {
        case 'video':
          media.querySelector('video')?.play();
          break;
        case 'external_video-youtube':
          media
            .querySelector('.js-youtube')
            ?.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
          break;
        case 'external_video-vimeo':
          media.querySelector('.js-vimeo')?.contentWindow.postMessage('{"method":"play"}', '*');
          break;
      }
    }
  }

  customElements.define('product-page', ProductPage);
}
